import { Share2, MonitorSmartphone, Clapperboard, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const SUPPORTING = [
  { icon: Share2, title: "Social Media", copy: "So your business looks active, credible and worth buying from when leads check you out." },
  { icon: MonitorSmartphone, title: "Websites + Landing Pages", copy: "Built to turn the traffic your ads generate into calls and customers." },
  { icon: Clapperboard, title: "Content + Creative", copy: "Ad creative, graphics and short-form video that make people stop and respond." },
  { icon: Sparkles, title: "Influencer Marketing", copy: "Creators used strategically to build attention and trust around your brand." },
];

export const SupportingServices = () => (
  <section className="relative border-t border-white/5 py-10 sm:py-14">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Beyond Ads</Eyebrow>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-4xl lg:text-5xl">
          Everything Else Your Marketing Needs.{" "}
          <span className="text-zinc-500">One Team Handles It.</span>
        </h2>
      </Reveal>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SUPPORTING.map((s, i) => (
          <Reveal key={s.title} delay={0.05 * i} className="h-full">
            <div
              data-testid={`supporting-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="h-full rounded-2xl border border-[#272732] bg-[#121217] p-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-purple-500/40"
            >
              <s.icon className="h-5 w-5 text-purple-400" />
              <h3 className="mt-4 font-display text-lg font-extrabold tracking-tight text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-500">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
